(function () {
  'use strict';

  if ('scrollRestoration' in history) history.scrollRestoration = 'auto';

  var toggle = document.querySelector('.nav-toggle');
  var links = document.querySelector('.nav-links');
  if (toggle && links) {
    toggle.addEventListener('click', function () {
      var open = links.classList.toggle('open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && links.classList.contains('open')) {
        links.classList.remove('open');
        toggle.setAttribute('aria-expanded', 'false');
      }
    });
  }

  (function navBlobB() {
    var nav = document.querySelector('.nav--b');
    var wrap = nav && nav.querySelector('.wrap');
    if (!nav || !wrap) return;
    var blob = document.createElement('span');
    blob.className = 'lg lg-blob'; blob.setAttribute('aria-hidden', 'true');
    wrap.insertBefore(blob, wrap.firstChild);

    var links = Array.prototype.slice.call(wrap.querySelectorAll('.nav-links a:not(.nav-buy)'));
    var current = null;
    function moveBlob(a, instant) {
      if (!a) { blob.classList.remove('on'); return; }
      var r = a.getBoundingClientRect(), w = wrap.getBoundingClientRect();
      if (instant) blob.style.transition = 'none';
      blob.style.setProperty('--bx', (r.left - w.left - wrap.clientLeft) + 'px');
      blob.style.setProperty('--bw', r.width + 'px');
      blob.classList.add('on');
      if (instant) { void blob.offsetWidth; blob.style.transition = ''; }
    }
    links.forEach(function (a) { a.addEventListener('pointerenter', function () { moveBlob(a); }); });
    var list = wrap.querySelector('.nav-links');
    function activeLink() { return links.filter(function (a) { return a.getAttribute('aria-current') === 'page'; })[0] || null; }
    if (list) list.addEventListener('pointerleave', function () { moveBlob(activeLink()); });
    function settle() { current = activeLink(); moveBlob(current, true); }
    settle();
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(settle);
    window.addEventListener('resize', function () { moveBlob(activeLink(), true); });
  })();

  var here = (location.pathname.split('/').pop() || 'index.html').toLowerCase();
  document.querySelectorAll('.nav-links a').forEach(function (a) {
    var target = (a.getAttribute('href') || '').split('#')[0].toLowerCase();
    if (target === here) a.setAttribute('aria-current', 'page');
  });

  var subLinks = Array.prototype.slice.call(document.querySelectorAll('.subnav a[href^="#"]'));
  if (subLinks.length && 'IntersectionObserver' in window) {
    var map = {};
    subLinks.forEach(function (a) { map[a.getAttribute('href').slice(1)] = a; });
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        subLinks.forEach(function (a) { a.classList.remove('active'); });
        var a = map[en.target.id];
        if (a) a.classList.add('active');
      });
    }, { rootMargin: '-40% 0px -55% 0px' });
    Object.keys(map).forEach(function (id) {
      var el = document.getElementById(id);
      if (el) io.observe(el);
    });
  }

  var CHARSET = '01:.#%&$+*/=<>?!';
  var PIPS = [
    [0,0,0, 0,1,0, 0,0,0],
    [1,0,0, 0,0,0, 0,0,1],
    [1,0,0, 0,1,0, 0,0,1],
    [1,0,1, 0,0,0, 1,0,1],
    [1,0,1, 0,1,0, 1,0,1],
    [1,0,1, 1,0,1, 1,0,1]
  ];
  function hash(a, b, c) {
    var h = (Math.imul(a, 2654435761) + Math.imul(b, 40503) + Math.imul(c, 131)) >>> 0;
    h ^= h >>> 13; h = Math.imul(h, 0x5bd1e995) >>> 0; h ^= h >>> 15;
    return h >>> 0;
  }
  function buildDice(el) {
    var face = parseInt(el.getAttribute('data-face') || '4', 10);
    if (isNaN(face) || face < 0 || face > 5) face = 4;
    var cells = [];
    el.textContent = '';
    for (var gy = 0; gy < 7; gy++) {
      for (var gx = 0; gx < 7; gx++) {
        var s = document.createElement('span');
        s.setAttribute('aria-hidden', 'true');
        el.appendChild(s);
        cells.push(s);
      }
    }
    var storm = 0, frame = 0, timer = null;
    function render() {
      var pg = PIPS[face];
      for (var i = 0; i < 49; i++) {
        var gx = i % 7, gy = (i / 7) | 0;
        var pipPos = (gx % 2 === 1) && (gy % 2 === 1);
        var px = (gx - 1) >> 1, py = (gy - 1) >> 1;
        var isPip = pipPos && pg[py * 3 + px] !== 0;
        var h = hash(gx + gy * 7, frame, 77);
        var noise = (h & 0xff) / 255;
        var cell = cells[i];
        cell.className = '';
        if (storm > 0.02 && noise < storm) {
          cell.textContent = CHARSET[(h >>> 8) % 16];
          cell.className = ((h >>> 5) & 3) === 0 ? 'hot' : 'pip';
          cell.style.opacity = (0.25 + 0.75 * (((h >>> 16) & 0xff) / 255) * storm).toFixed(2);
        } else if (isPip) {
          cell.textContent = '1';
          cell.className = storm > 0.02 ? 'hot' : 'pip';
          cell.style.opacity = '';
        } else {
          var hh = hash(gx * 31 + gy, 0, 913);
          cell.textContent = (hh & 1) ? '0' : ':';
          cell.style.opacity = '';
        }
      }
    }
    function tick() {
      frame++;
      if (storm > 0) {
        storm -= 0.028;
        if (storm < 0) storm = 0;
        if (storm > 0.5 && (frame & 1) === 0) face = (Math.random() * 6) | 0;
      }
      render();
      if (storm <= 0) { clearInterval(timer); timer = null; el.classList.remove('storm'); }
    }
    function roll() {
      storm = 1;
      face = (Math.random() * 6) | 0;
      el.classList.add('storm');
      if (!timer) timer = setInterval(tick, 1000 / 60);
      el.dispatchEvent(new CustomEvent('reroll', { bubbles: true }));
    }
    el.addEventListener('click', roll);
    el.addEventListener('keydown', function (e) {
      if (e.key === ' ' || e.key === 'Enter') { e.preventDefault(); roll(); }
    });
    if (!el.hasAttribute('tabindex')) el.setAttribute('tabindex', '0');
    if (!el.hasAttribute('role')) el.setAttribute('role', 'button');
    if (!el.hasAttribute('aria-label')) el.setAttribute('aria-label', 'REROLL dice (demo)');
    render();
    if (el.hasAttribute('data-autoroll')) setTimeout(roll, 600);
  }
  document.querySelectorAll('.mock-dice').forEach(buildDice);

  function lcg(seed) {
    var s = seed >>> 0;
    return function () { s = (Math.imul(s, 1664525) + 1013904223) >>> 0; return s / 4294967296; };
  }
  function makeWavePath(seed, w, h, hits) {
    var rnd = lcg(seed);
    var n = 220, mid = h / 2, half = h * 0.48;
    var d = '';
    var env = 0;
    for (var i = 0; i < n; i++) {
      var t = i / n;
      var onHit = false;
      for (var k = 0; k < hits.length; k++) {
        if (Math.abs(t - hits[k]) < 0.004) { onHit = true; break; }
      }
      if (onHit) env = 0.75 + rnd() * 0.25;
      var v = (rnd() * 2 - 1) * env;
      env *= 0.86;
      if (env < 0.03) env = 0.03;
      var x = (i / (n - 1)) * w, y = mid - v * half;
      d += (i === 0 ? 'M' : 'L') + x.toFixed(1) + ' ' + y.toFixed(1);
    }
    return d;
  }
  document.querySelectorAll('svg.mock-wave[data-seed]').forEach(function (svg) {
    var seed = parseInt(svg.getAttribute('data-seed'), 10) || 1;
    var w = 400, h = 48;
    svg.setAttribute('viewBox', '0 0 ' + w + ' ' + h);
    svg.setAttribute('preserveAspectRatio', 'none');
    var hits = (svg.getAttribute('data-hits') || '0,.125,.25,.375,.5,.625,.75,.875')
      .split(',').map(parseFloat);
    var d = makeWavePath(seed, w, h, hits);
    var sweep = svg.hasAttribute('data-sweep');
    var NS = 'http://www.w3.org/2000/svg';
    if (sweep) {
      var dim = document.createElementNS(NS, 'path');
      dim.setAttribute('d', d); dim.setAttribute('class', 'dim');
      svg.appendChild(dim);
      var clip = document.createElementNS(NS, 'clipPath');
      var id = 'clip' + seed + Math.floor(Math.random() * 1e6);
      clip.setAttribute('id', id);
      var rect = document.createElementNS(NS, 'rect');
      rect.setAttribute('x', '0'); rect.setAttribute('y', '-2');
      rect.setAttribute('width', '0'); rect.setAttribute('height', String(h + 4));
      clip.appendChild(rect);
      svg.appendChild(clip);
      var lit = document.createElementNS(NS, 'path');
      lit.setAttribute('d', d);
      lit.setAttribute('clip-path', 'url(#' + id + ')');
      svg.appendChild(lit);
      var start = performance.now();
      var period = parseFloat(svg.getAttribute('data-period') || '4000');
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduce) { rect.setAttribute('width', String(w * 0.62)); }
      else {
        (function frame(now) {
          var p = ((now - start) % period) / period;
          rect.setAttribute('width', (p * w).toFixed(1));
          requestAnimationFrame(frame);
        })(start);
      }
    } else {
      var path = document.createElementNS(NS, 'path');
      path.setAttribute('d', d);
      svg.appendChild(path);
    }
  });

  document.querySelectorAll('[data-faq-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var open = btn.getAttribute('data-faq-toggle') === 'open';
      document.querySelectorAll('.faq details').forEach(function (d) { d.open = open; });
    });
  });

  function openHash() {
    if (!location.hash) return;
    var el = document.getElementById(location.hash.slice(1));
    if (el && el.tagName === 'DETAILS') el.open = true;
  }
  openHash();
  window.addEventListener('hashchange', openHash);

  (function heroHorizon() {
    var box = document.querySelector('.hero-horizon');
    if (!box) return;
    var rainC = document.createElement('canvas'); rainC.className = 'rain';
    var planetC = document.createElement('canvas'); planetC.className = 'planet';
    var boltC = document.createElement('canvas'); boltC.className = 'bolts';
    box.appendChild(rainC); box.appendChild(planetC); box.appendChild(boltC);
    var rctx = rainC.getContext('2d'), pctx = planetC.getContext('2d'), bctx = boltC.getContext('2d');
    if (!rctx || !pctx || !bctx) return;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function rng(seed) {
      var s = seed >>> 0;
      return function () { s = (Math.imul(s, 1664525) + 1013904223) >>> 0; return s / 4294967296; };
    }
    function smooth(t) { return t * t * (3 - 2 * t); }

    var LAT = 64, lat = new Float32Array(LAT * LAT);
    (function () { var r = rng(0x5eed); for (var i = 0; i < lat.length; i++) lat[i] = r(); })();
    function vnoise(x, y) {
      var xi = Math.floor(x), yi = Math.floor(y), xf = smooth(x - xi), yf = smooth(y - yi);
      var x0 = xi & (LAT - 1), x1 = (xi + 1) & (LAT - 1), y0 = yi & (LAT - 1), y1 = (yi + 1) & (LAT - 1);
      var a = lat[y0 * LAT + x0], b = lat[y0 * LAT + x1], c = lat[y1 * LAT + x0], d = lat[y1 * LAT + x1];
      var top = a + (b - a) * xf, bot = c + (d - c) * xf;
      return top + (bot - top) * yf;
    }
    function fbm(x, y, oct) {
      var v = 0, amp = 0.5, sum = 0;
      for (var i = 0; i < oct; i++) { v += vnoise(x, y) * amp; sum += amp; x = x * 2.03 + 17.1; y = y * 2.03 + 9.7; amp *= 0.5; }
      return v / sum;
    }
    function ridged(x, y, oct) {
      var v = 0, amp = 0.5, sum = 0;
      for (var i = 0; i < oct; i++) { var n = 1 - Math.abs(vnoise(x, y) * 2 - 1); v += n * n * amp; sum += amp; x = x * 2.1 + 3.3; y = y * 2.1 + 7.9; amp *= 0.5; }
      return v / sum;
    }
    function cloudTexture(w, h) {
      var off = document.createElement('canvas'); off.width = w; off.height = h;
      var c = off.getContext('2d'), img = c.createImageData(w, h), d = img.data;
      for (var y = 0; y < h; y++) {
        for (var x = 0; x < w; x++) {
          var u = x / w * 5.5, v = y / h * 2.2;
          var q = fbm(u + 3.1, v + 1.7, 4);
          var n = fbm(u + 0.9 * q, v + 0.6 * q, 6);
          var s = ridged(u * 1.6 + 11, v * 1.6 + 5, 4);
          var cloud = Math.min(1, Math.max(0, (n * 0.72 + s * 0.28) - 0.42) * 1.9);
          var i = (y * w + x) * 4;
          d[i] = 150 + cloud * 70; d[i + 1] = 185 + cloud * 55; d[i + 2] = 235;
          d[i + 3] = cloud * cloud * 190;
        }
      }
      c.putImageData(img, 0, 0);
      return off;
    }
    function grainTexture(w, h) {
      var off = document.createElement('canvas'); off.width = w; off.height = h;
      var c = off.getContext('2d'), img = c.createImageData(w, h), d = img.data;
      for (var y = 0; y < h; y++) {
        for (var x = 0; x < w; x++) {
          var n = fbm(x / w * 26 + 41, y / h * 13 + 23, 4);
          var g = 175 + n * 80;
          var i = (y * w + x) * 4;
          d[i] = g; d[i + 1] = g; d[i + 2] = Math.min(255, g + 10); d[i + 3] = 255;
        }
      }
      c.putImageData(img, 0, 0);
      return off;
    }
    var clouds = null, grain = null;

    var W = 0, H = 0, dpr = 1, apexY = 0, R = 0, cx = 0, cy = 0;
    function size() {
      W = Math.max(1, Math.round(box.clientWidth)); H = Math.max(1, Math.round(box.clientHeight));
      dpr = Math.min(1.5, window.devicePixelRatio || 1);
      [rainC, planetC, boltC].forEach(function (c) {
        c.width = Math.round(W * dpr); c.height = Math.round(H * dpr);
        c.getContext('2d').setTransform(dpr, 0, 0, dpr, 0, 0);
      });
      var hy = parseFloat(getComputedStyle(box).getPropertyValue('--hy')) || 46;
      apexY = H * hy / 100;
      R = W * 1.55;
      cx = W / 2; cy = apexY + R;
    }
    function limbY(x) {
      var dx = x - cx, t = R * R - dx * dx;
      return t > 0 ? cy - Math.sqrt(t) : cy;
    }

    function renderPlanet() {
      var ctx = pctx;
      ctx.clearRect(0, 0, W, H);

      var atm = ctx.createRadialGradient(cx, cy, R, cx, cy, R * 1.11);
      atm.addColorStop(0,    'rgba(120,165,235,0.55)');
      atm.addColorStop(0.08, 'rgba(80,125,215,0.30)');
      atm.addColorStop(0.3,  'rgba(45,80,170,0.12)');
      atm.addColorStop(1,    'rgba(20,40,110,0)');
      ctx.fillStyle = atm; ctx.fillRect(0, 0, W, H);

      var glare = ctx.createRadialGradient(cx, apexY, 0, cx, apexY, W * 0.36);
      glare.addColorStop(0,    'rgba(255,255,255,0.42)');
      glare.addColorStop(0.03, 'rgba(215,232,255,0.30)');
      glare.addColorStop(0.10, 'rgba(140,185,250,0.17)');
      glare.addColorStop(0.28, 'rgba(70,115,210,0.07)');
      glare.addColorStop(1,    'rgba(40,70,160,0)');
      ctx.fillStyle = glare; ctx.fillRect(0, 0, W, H);
      ctx.save(); ctx.translate(cx, apexY); ctx.scale(1, 0.22);
      var glint = ctx.createRadialGradient(0, 0, 0, 0, 0, W * 0.42);
      glint.addColorStop(0,   'rgba(235,245,255,0.35)');
      glint.addColorStop(0.2, 'rgba(160,200,255,0.16)');
      glint.addColorStop(1,   'rgba(120,170,255,0)');
      ctx.fillStyle = glint; ctx.fillRect(-W, -W, 2 * W, 2 * W);
      ctx.restore();

      ctx.save();
      ctx.beginPath(); ctx.arc(cx, cy, R, 0, 6.2832); ctx.clip();
      var base = ctx.createRadialGradient(cx, cy, R * 0.7, cx, cy, R);
      base.addColorStop(0,    '#02050c');
      base.addColorStop(0.55, '#061530');
      base.addColorStop(0.85, '#0d2a55');
      base.addColorStop(1,    '#1a4a86');
      ctx.fillStyle = base; ctx.fillRect(0, 0, W, H);

      var bandTop = apexY - 2, bandH = H - bandTop + 2;
      if (!clouds) { clouds = cloudTexture(384, 192); grain = grainTexture(256, 128); }
      ctx.globalCompositeOperation = 'multiply'; ctx.globalAlpha = 0.55;
      ctx.drawImage(grain, 0, bandTop, W, bandH);
      ctx.globalCompositeOperation = 'screen'; ctx.globalAlpha = 0.5;
      ctx.drawImage(clouds, 0, bandTop, W, bandH);
      ctx.globalAlpha = 1; ctx.globalCompositeOperation = 'source-over';

      var down = ctx.createLinearGradient(0, apexY, 0, H);
      down.addColorStop(0, 'rgba(2,4,10,0)'); down.addColorStop(0.45, 'rgba(2,4,10,0.35)'); down.addColorStop(1, 'rgba(2,4,10,0.78)');
      ctx.fillStyle = down; ctx.fillRect(0, 0, W, H);
      var side = ctx.createLinearGradient(0, 0, W, 0);
      side.addColorStop(0, 'rgba(2,4,10,0.55)'); side.addColorStop(0.35, 'rgba(2,4,10,0)'); side.addColorStop(0.65, 'rgba(2,4,10,0)'); side.addColorStop(1, 'rgba(2,4,10,0.55)');
      ctx.fillStyle = side; ctx.fillRect(0, 0, W, H);

      var fres = ctx.createRadialGradient(cx, cy, R * 0.93, cx, cy, R);
      fres.addColorStop(0,    'rgba(120,175,255,0)');
      fres.addColorStop(0.75, 'rgba(120,175,255,0.10)');
      fres.addColorStop(0.96, 'rgba(170,210,255,0.45)');
      fres.addColorStop(1,    'rgba(230,242,255,0.85)');
      ctx.fillStyle = fres; ctx.fillRect(0, 0, W, H);

      ctx.save(); ctx.translate(cx, apexY + H * 0.16); ctx.scale(1, 0.32);
      ctx.globalCompositeOperation = 'screen';
      var spec = ctx.createRadialGradient(0, 0, 0, 0, 0, W * 0.34);
      spec.addColorStop(0,   'rgba(190,215,255,0.22)');
      spec.addColorStop(0.5, 'rgba(110,160,240,0.08)');
      spec.addColorStop(1,   'rgba(80,130,230,0)');
      ctx.fillStyle = spec; ctx.fillRect(-W, -W, 2 * W, 2 * W);
      ctx.restore();
      ctx.restore();

      ctx.save(); ctx.lineWidth = 1.2;
      ctx.strokeStyle = 'rgba(225,240,255,0.75)';
      ctx.shadowColor = 'rgba(150,200,255,0.9)'; ctx.shadowBlur = 6;
      ctx.beginPath(); ctx.arc(cx, cy, R, 0, 6.2832); ctx.stroke();
      ctx.restore();

      var vig = ctx.createRadialGradient(cx, H * 0.45, W * 0.25, cx, H * 0.45, W * 0.8);
      vig.addColorStop(0, 'rgba(0,0,0,0)'); vig.addColorStop(1, 'rgba(0,0,0,0.55)');
      ctx.fillStyle = vig; ctx.fillRect(0, 0, W, H);
    }

    var GLYPHS = '01:#%&+*<>', CS = 16, cols = [], frame = 0;
    function newCol(initial) {
      return {
        y: initial ? Math.random() * apexY : -20 - Math.random() * apexY * 0.8,
        speed: 1.0 + Math.random() * 2.4,
        len: 6 + ((Math.random() * 16) | 0)
      };
    }
    function resetCols() {
      var n = Math.floor(W / CS) + 1;
      while (cols.length < n) cols.push(newCol(true));
      cols.length = n;
    }
    function drawRain() {
      var ctx = rctx;
      ctx.clearRect(0, 0, W, H);
      ctx.font = 'bold 12px "JetBrains Mono", "Cascadia Mono", Consolas, ui-monospace, monospace';
      ctx.textBaseline = 'alphabetic';
      var f4 = (frame / 4) | 0;
      var fadeBand = Math.max(60, apexY * 0.35);
      for (var ci = 0; ci < cols.length; ci++) {
        var col = cols[ci], x = ci * CS + 4;
        var ly = limbY(x);
        var headRow = Math.floor(col.y / CS);
        for (var k = 0; k < col.len; k++) {
          var row = headRow - k;
          if (row < 0) break;
          var gy = row * CS + 12;
          var above = ly - gy;
          if (above < 6) continue;
          var hFade = Math.min(1, above / fadeBand);
          var h = hash(ci * 91 + row, f4, 55);
          var t = k / col.len;
          var a = (k === 0 ? 0.9 : 0.55 * (1 - t) * (1 - t) + 0.04) * hFade;
          ctx.fillStyle = k === 0
            ? 'rgba(205,232,255,' + a.toFixed(3) + ')'
            : 'rgba(70,140,255,' + a.toFixed(3) + ')';
          ctx.fillText(GLYPHS[h % 10], x, gy);
        }
      }
    }
    function stepRain() {
      frame++;
      for (var i = 0; i < cols.length; i++) {
        var col = cols[i];
        col.y += col.speed;
        if (col.y - col.len * CS > cy - Math.sqrt(Math.max(0, R * R - (i * CS + 4 - cx) * (i * CS + 4 - cx))) + 40) cols[i] = newCol(false);
      }
    }

    var bolts = [], spawnAcc = 0;
    var rootCS = getComputedStyle(document.documentElement);
    function evar(name, fb) { var v = parseFloat(rootCS.getPropertyValue(name)); return isNaN(v) ? fb : v; }
    function videoRect() {
      var f = document.querySelector('.hero-video-frame');
      if (!f) return null;
      var a = f.getBoundingClientRect(), b = box.getBoundingClientRect();
      return { x: a.left - b.left, y: a.top - b.top, w: a.width, h: a.height };
    }
    function dodge(x, y, vr) {
      if (!vr || x < vr.x - 10 || x > vr.x + vr.w + 10) return y;
      var top = vr.y, bot = vr.y + vr.h;
      if (y < top || y > bot) return y;
      var toTop = y - top, toBot = bot - y;
      return toTop < toBot ? top - 6 - Math.random() * 18 : bot + 6 + Math.random() * 18;
    }
    function jaggedPath(x0, y0, x1, y1, roughness, vr) {
      var pts = [{ x: x0, y: y0 }, { x: x1, y: y1 }];
      var disp = roughness;
      for (var it = 0; it < 6; it++) {
        var next = [];
        for (var i = 0; i < pts.length - 1; i++) {
          var a = pts[i], b = pts[i + 1];
          var mx = (a.x + b.x) / 2, my = (a.y + b.y) / 2;
          var nx = -(b.y - a.y), ny = (b.x - a.x), len = Math.sqrt(nx * nx + ny * ny) || 1;
          var off = (Math.random() - 0.5) * 2 * disp;
          next.push(a, { x: mx + nx / len * off, y: my + ny / len * off });
        }
        next.push(pts[pts.length - 1]);
        pts = next;
        disp *= 0.55;
      }
      if (vr) for (var k = 0; k < pts.length; k++) pts[k].y = dodge(pts[k].x, pts[k].y, vr);
      return pts;
    }
    function spawnBolt() {
      var vr = videoRect();
      var branches = Math.round(evar('--e-branch', 3));
      var y0 = H * (0.12 + Math.random() * 0.55);
      var y1 = H * (0.12 + Math.random() * 0.55);
      var main = jaggedPath(-10, y0, W + 10, y1, H * 0.22, vr);
      var segs = [{ pts: main, w: 1 }];
      for (var b = 0; b < branches; b++) {
        var at = main[(Math.random() * (main.length - 2) + 1) | 0];
        var len = 60 + Math.random() * W * 0.22;
        var ang = (Math.random() - 0.5) * 1.6 + (Math.random() < 0.5 ? 0 : Math.PI * 0.15);
        var ex = at.x + Math.cos(ang) * len, ey = at.y + Math.sin(ang) * len;
        segs.push({ pts: jaggedPath(at.x, at.y, ex, ey, len * 0.25, vr), w: 0.45 + Math.random() * 0.25 });
      }
      bolts.push({ segs: segs, age: 0, life: 0.28 + Math.random() * 0.3, flick: Math.random() });
    }
    function stepBolts(dt) {
      var rate = evar('--e-rate', 1.2);
      spawnAcc += dt * rate;
      while (spawnAcc >= 1) { spawnBolt(); spawnAcc -= 1; }
      for (var i = bolts.length - 1; i >= 0; i--) {
        var bt = bolts[i]; bt.age += dt; bt.flick = Math.random();
        if (bt.age > bt.life) bolts.splice(i, 1);
      }
    }
    function drawBolts() {
      var ctx = bctx;
      ctx.clearRect(0, 0, W, H);
      if (!bolts.length) return;
      var thick = evar('--e-thick', 1.6);
      ctx.save();
      ctx.globalCompositeOperation = 'lighter';
      ctx.lineCap = 'round'; ctx.lineJoin = 'round';
      bolts.forEach(function (bt) {
        var t = bt.age / bt.life;
        var a = (t < 0.15 ? t / 0.15 : 1 - (t - 0.15) / 0.85);
        a *= 0.75 + 0.25 * bt.flick;
        bt.segs.forEach(function (sg) {
          var path = new Path2D();
          sg.pts.forEach(function (p, i) { if (i) path.lineTo(p.x, p.y); else path.moveTo(p.x, p.y); });
          ctx.shadowColor = 'rgba(90,150,255,' + (0.9 * a).toFixed(3) + ')'; ctx.shadowBlur = 18 * sg.w + 6;
          ctx.strokeStyle = 'rgba(80,140,255,' + (0.35 * a * sg.w).toFixed(3) + ')';
          ctx.lineWidth = thick * 3.2 * sg.w; ctx.stroke(path);
          ctx.shadowBlur = 8 * sg.w;
          ctx.strokeStyle = 'rgba(225,238,255,' + (0.95 * a * sg.w).toFixed(3) + ')';
          ctx.lineWidth = thick * sg.w; ctx.stroke(path);
        });
      });
      ctx.restore();
    }

    var running = false, visible = true, last = 0, acc = 0, raf = 0;
    function loop(now) {
      if (!running) return;
      if (!last) last = now;
      acc += Math.min(100, now - last); last = now;
      var stepped = false;
      while (acc >= 1000 / 60) { stepRain(); stepBolts(1 / 60); acc -= 1000 / 60; stepped = true; }
      if (stepped) { drawRain(); drawBolts(); }
      raf = requestAnimationFrame(loop);
    }
    function start() { if (running || reduce || !visible || document.hidden) return; running = true; last = 0; raf = requestAnimationFrame(loop); }
    function stop() { running = false; cancelAnimationFrame(raf); }

    function render() { size(); resetCols(); renderPlanet(); drawRain(); }
    box._render = render;
    var pending = 0;
    function schedule() { cancelAnimationFrame(pending); pending = requestAnimationFrame(render); }
    if ('ResizeObserver' in window) new ResizeObserver(schedule).observe(box);
    else window.addEventListener('resize', schedule);
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (en) { visible = en[0].isIntersecting; if (visible) start(); else stop(); }).observe(box);
    }
    document.addEventListener('visibilitychange', function () { if (document.hidden) stop(); else start(); });

    render();
    start();
  })();

  (function tunePanel() {
    var h1 = document.querySelector('.hero h1');
    var lead = document.querySelector('.hero .lead');
    if (!h1) return;
    var root = document.documentElement;
    var sub = document.querySelector('.hero-sub');
    var horizon = document.querySelector('.hero-horizon');
    var panel = null;
    var STORE = 'drumhacker-tune';

    function px(el, prop) { return parseFloat(getComputedStyle(el)[prop]) || 0; }
    function rootVar(name, fallback) { return parseFloat(getComputedStyle(root).getPropertyValue(name)) || fallback; }

    var GROUPS = [
      { name: 'Headline', items: [
        { key: 'h1',   label: 'DRUMHACKER size',          min: 24,  max: 180, step: 1,   unit: 'px', prop: '--h1-size' },
        { key: 'sub',  label: 'Subtitle size',            min: 8,   max: 40,  step: 0.5, unit: 'px', prop: '--sub-size' },
        { key: 'gap',  label: 'Gap: DRUMHACKER → subtitle', min: -40, max: 60, step: 1, unit: 'px', prop: '--sub-gap' },
        { key: 'gap2', label: 'Gap: subtitle → buttons',    min: 0,   max: 120, step: 1, unit: 'px', prop: '--sub-gap-after' }
      ]},
      { name: 'Description', items: [
        { key: 'width', label: 'Container width', min: 30, max: 140, step: 1,   unit: 'ch', prop: '--desc-width' },
        { key: 'desc',  label: 'Font size',       min: 10, max: 26,  step: 0.5, unit: 'px', prop: '--desc-size' },
        { key: 'justify', label: 'Justify (even left & right edges)', type: 'check' }
      ]},
      { name: 'Video', items: [
        { key: 'fade',  label: 'Fade start (from top of video)', min: 0,   max: 100, step: 1,    unit: '%', prop: '--fade-start' },
        { key: 'curve', label: 'Fade curve (<1 drops late · 1 straight · >1 drops early)', min: 0.2, max: 4, step: 0.05, unit: '' }
      ]},
      { name: 'Planet', items: [
        { key: 'pop',  label: 'Opacity',                          min: 0,    max: 100, step: 1, unit: '%',   prop: '--p-op', pct: true },
        { key: 'hy',   label: 'Horizon height (from top of hero)', min: 10,  max: 90,  step: 1, unit: '%',   prop: '--hy', target: 'horizon' },
        { key: 'phue', label: 'Hue shift',   min: -180, max: 180, step: 1, unit: 'deg', prop: '--p-hue' },
        { key: 'psat', label: 'Saturation',  min: 0,    max: 250, step: 1, unit: '%',   prop: '--p-sat' },
        { key: 'pbri', label: 'Brightness',  min: 30,   max: 200, step: 1, unit: '%',   prop: '--p-bri' }
      ]},
      { name: 'Matrix rain', items: [
        { key: 'rop',  label: 'Opacity',     min: 0,    max: 100, step: 1, unit: '%',   prop: '--r-op', pct: true },
        { key: 'rhue', label: 'Hue shift',   min: -180, max: 180, step: 1, unit: 'deg', prop: '--r-hue' },
        { key: 'rsat', label: 'Saturation',  min: 0,    max: 250, step: 1, unit: '%',   prop: '--r-sat' },
        { key: 'rbri', label: 'Brightness',  min: 30,   max: 200, step: 1, unit: '%',   prop: '--r-bri' }
      ]},
      { name: 'Buy button', items: [
        { key: 'bhue',   label: 'Hue shift',        min: -180, max: 180, step: 1,   unit: 'deg', prop: '--b-hue' },
        { key: 'bsat',   label: 'Saturation',       min: 0,    max: 250, step: 1,   unit: '%',   prop: '--b-sat' },
        { key: 'bbri',   label: 'Brightness',       min: 30,   max: 200, step: 1,   unit: '%',   prop: '--b-bri' },
        { key: 'bsweep', label: 'Shine sweep time', min: 0.5,  max: 10,  step: 0.1, unit: 's',   prop: '--b-sweep' }
      ]},
      { name: 'Electricity', items: [
        { key: 'eop',     label: 'Opacity',            min: 0,    max: 100, step: 1,    unit: '%',   prop: '--e-op', pct: true },
        { key: 'erate',   label: 'Bolts per second',   min: 0,    max: 8,   step: 0.1,  unit: '',    prop: '--e-rate' },
        { key: 'ebranch', label: 'Branches per bolt',  min: 0,    max: 10,  step: 1,    unit: '',    prop: '--e-branch' },
        { key: 'ethick',  label: 'Thickness',          min: 0.5,  max: 5,   step: 0.1,  unit: 'px',  prop: '--e-thick', raw: true },
        { key: 'ehue',    label: 'Hue shift',          min: -180, max: 180, step: 1,    unit: 'deg', prop: '--e-hue' },
        { key: 'esat',    label: 'Saturation',         min: 0,    max: 250, step: 1,    unit: '%',   prop: '--e-sat' },
        { key: 'ebri',    label: 'Brightness',         min: 30,   max: 200, step: 1,    unit: '%',   prop: '--e-bri' }
      ]}
    ];
    var ITEMS = {};
    GROUPS.forEach(function (g) { g.items.forEach(function (it) { ITEMS[it.key] = it; }); });

    var saved = {};
    try { saved = JSON.parse(localStorage.getItem(STORE) || '{}') || {}; } catch (e) { saved = {}; }
    function persist() { try { localStorage.setItem(STORE, JSON.stringify(saved)); } catch (e) {} }

    var chPx = (lead ? px(lead, 'fontSize') : rootVar('--desc-size', 15)) * 0.6;
    var actions = document.querySelector('.hero-actions');
    var defaults = {
      h1: Math.round(px(h1, 'fontSize')),
      sub: sub ? px(sub, 'fontSize') : 16,
      gap: sub ? Math.round(px(sub, 'marginTop')) : 0,
      gap2: actions ? Math.round(px(actions, 'marginTop')) : 20,
      width: lead ? Math.round(lead.getBoundingClientRect().width / chPx) : rootVar('--desc-width', 74),
      desc: lead ? px(lead, 'fontSize') : rootVar('--desc-size', 15),
      fade: rootVar('--fade-start', 79),
      curve: 3.1,
      hy: horizon ? parseFloat(getComputedStyle(horizon).getPropertyValue('--hy')) || 30 : 30,
      pop: rootVar('--p-op', 1) * 100, phue: rootVar('--p-hue', 6), psat: rootVar('--p-sat', 61), pbri: rootVar('--p-bri', 42),
      rop: rootVar('--r-op', 1) * 100, rhue: rootVar('--r-hue', 0), rsat: rootVar('--r-sat', 26), rbri: rootVar('--r-bri', 100),
      eop: rootVar('--e-op', 1) * 100, erate: rootVar('--e-rate', 0.6), ebranch: rootVar('--e-branch', 10), ethick: rootVar('--e-thick', 3.2),
      ehue: rootVar('--e-hue', 0), esat: rootVar('--e-sat', 100), ebri: rootVar('--e-bri', 62),
      bhue: rootVar('--b-hue', -41), bsat: rootVar('--b-sat', 250), bbri: rootVar('--b-bri', 100), bsweep: rootVar('--b-sweep', 2.8)
    };
    Object.keys(saved).forEach(function (k) { if (k in defaults) apply(k, parseFloat(saved[k])); });
    if (saved.justify) apply('justify', true);
    applyMask();

    function apply(key, v) {
      var it = ITEMS[key];
      if (key === 'justify') {
        if (v) root.style.setProperty('--desc-align', 'justify'); else root.style.removeProperty('--desc-align');
        return;
      }
      if (it && it.prop) {
        var target = it.target === 'horizon' ? horizon : root;
        var val = it.pct ? String(v / 100) : it.raw ? String(v) : v + it.unit;
        if (target) target.style.setProperty(it.prop, val);
      }
      if (key === 'hy' && horizon && horizon._render) horizon._render();
      if (key === 'fade' || key === 'curve') applyMask();
    }

    function applyMask() {
      var frame = document.querySelector('.hero-video-frame');
      if (!frame) return;
      var start = parseFloat(root.style.getPropertyValue('--fade-start')) || defaults.fade;
      var k = parseFloat(saved.curve != null ? saved.curve : defaults.curve) || 1;
      if (k === 1 && !root.style.getPropertyValue('--fade-start')) { frame.style.maskImage = ''; frame.style.webkitMaskImage = ''; return; }
      var stops = ['#000 ' + start + '%'];
      for (var i = 1; i <= 12; i++) {
        var t = i / 12, a = Math.pow(1 - t, k);
        stops.push('rgba(0,0,0,' + a.toFixed(3) + ') ' + (start + (100 - start) * t).toFixed(2) + '%');
      }
      var g = 'linear-gradient(to bottom, ' + stops.join(', ') + ')';
      frame.style.webkitMaskImage = g; frame.style.maskImage = g;
    }

    function build() {
      panel = document.createElement('div');
      panel.className = 'tune';
      panel.setAttribute('role', 'dialog');
      panel.setAttribute('aria-label', 'Adjustment panel');
      var html = '<h5>Adjust <span>A = hide · dbl-click a slider = reset · dbl-click here = reset all</span></h5>';
      GROUPS.forEach(function (g) {
        html += '<details><summary>' + g.name + '</summary>';
        g.items.forEach(function (it) {
          if (it.type === 'check') {
            html += '<label class="check"><input type="checkbox" data-key="' + it.key + '"> ' + it.label + '</label>';
          } else {
            html += '<label><span class="nm">' + it.label + '</span><b data-out="' + it.key + '"></b>' +
              '<input type="range" data-key="' + it.key + '" min="' + it.min + '" max="' + it.max + '" step="' + it.step + '"></label>';
          }
        });
        html += '</details>';
      });
      html += '<textarea readonly aria-label="Current values"></textarea>' +
              '<div class="hint">Copy the box and send it to me; I will hardcode it.</div>';
      panel.innerHTML = html;
      document.body.appendChild(panel);

      var inputs = {};
      panel.querySelectorAll('input[type="range"]').forEach(function (inp) {
        var key = inp.getAttribute('data-key');
        inputs[key] = inp;
        inp.value = (key in saved) ? saved[key] : defaults[key];
        inp.addEventListener('input', function () {
          saved[key] = inp.value; persist();
          apply(key, parseFloat(inp.value));
          report();
        });
        inp.addEventListener('dblclick', function () { reset(key); });
        inp.parentNode.addEventListener('dblclick', function (e) { if (e.target !== inp) reset(key); });
      });
      var justify = panel.querySelector('input[data-key="justify"]');
      justify.checked = !!saved.justify;
      justify.addEventListener('change', function () {
        apply('justify', justify.checked);
        if (justify.checked) saved.justify = true; else delete saved.justify;
        persist(); report();
      });
      panel.querySelector('h5').addEventListener('dblclick', function () {
        Object.keys(inputs).forEach(reset);
        justify.checked = false; apply('justify', false); delete saved.justify; persist(); report();
      });
      report();

      function reset(key) {
        var it = ITEMS[key];
        inputs[key].value = defaults[key];
        delete saved[key]; persist();
        if (it && it.prop) {
          var target = it.target === 'horizon' ? horizon : root;
          if (target) target.style.removeProperty(it.prop);
        }
        if (key === 'hy' && horizon && horizon._render) horizon._render();
        if (key === 'fade' || key === 'curve') applyMask();
        report();
      }
      function report() {
        var lines = [];
        GROUPS.forEach(function (g) {
          g.items.forEach(function (it) {
            if (it.type === 'check') {
              lines.push(g.name + ' · ' + it.label.split(' (')[0] + ': ' + (justify.checked ? 'on' : 'off'));
            } else {
              var v = inputs[it.key].value;
              panel.querySelector('[data-out="' + it.key + '"]').textContent = v + it.unit;
              lines.push(g.name + ' · ' + it.label.split(' (')[0] + ': ' + v + it.unit);
            }
          });
        });
        panel.querySelector('textarea').value = lines.join('\n');
      }
    }

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'a' && e.key !== 'A') return;
      if (e.ctrlKey || e.metaKey || e.altKey) return;
      var t = e.target;
      if (t && (t.tagName === 'INPUT' || t.tagName === 'TEXTAREA' || t.isContentEditable)) return;
      e.preventDefault();
      if (!panel) { build(); return; }
      panel.hidden = !panel.hidden;
    });
  })();

  (function electricButtons() {
    var ARCS_ENABLED = false;
    if (!ARCS_ENABLED) return;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce) return;
    document.querySelectorAll('.btn--electric').forEach(function (btn) {
      var canvas = document.createElement('canvas');
      canvas.className = 'elec'; canvas.setAttribute('aria-hidden', 'true');
      btn.appendChild(canvas);
      var ctx = canvas.getContext('2d');
      if (!ctx) return;
      var PAD = 20, W = 0, H = 0, bw = 0, bh = 0, dpr = 1;
      function size() {
        bw = btn.offsetWidth; bh = btn.offsetHeight;
        W = bw + PAD * 2; H = bh + PAD * 2;
        dpr = Math.min(2, window.devicePixelRatio || 1);
        canvas.width = Math.round(W * dpr); canvas.height = Math.round(H * dpr);
        ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      }
      function edgePoint(t) {
        var P = 2 * (bw + bh); t = ((t % P) + P) % P;
        var x, y, nx, ny;
        if (t < bw)                { x = t;                    y = 0;  nx = 0;  ny = -1; }
        else if (t < bw + bh)      { x = bw;                   y = t - bw; nx = 1; ny = 0; }
        else if (t < 2 * bw + bh)  { x = bw - (t - bw - bh);   y = bh; nx = 0;  ny = 1; }
        else                       { x = 0;                    y = bh - (t - 2 * bw - bh); nx = -1; ny = 0; }
        return { x: x + PAD, y: y + PAD, nx: nx, ny: ny };
      }
      var arcs = [], acc = 0;
      function spawn() {
        var P = 2 * (bw + bh);
        var start = Math.random() * P, len = 18 + Math.random() * 50, dir = Math.random() < 0.5 ? 1 : -1;
        var pts = [], n = 6 + ((len / 6) | 0);
        for (var i = 0; i <= n; i++) {
          var p = edgePoint(start + dir * len * i / n);
          var off = (i === 0 || i === n) ? 0 : (Math.random() - 0.5) * 7 + 2.5;
          pts.push({ x: p.x + p.nx * off, y: p.y + p.ny * off });
        }
        var branch = null;
        if (Math.random() < 0.5) {
          var k = 1 + ((Math.random() * (n - 2)) | 0), b0 = pts[k], e = edgePoint(start + dir * len * k / n);
          var bl = 6 + Math.random() * 12, bx = b0.x + e.nx * bl + (Math.random() - 0.5) * 8, by = b0.y + e.ny * bl + (Math.random() - 0.5) * 8;
          branch = [b0, { x: (b0.x + bx) / 2 + (Math.random() - 0.5) * 4, y: (b0.y + by) / 2 + (Math.random() - 0.5) * 4 }, { x: bx, y: by }];
        }
        arcs.push({ pts: pts, branch: branch, age: 0, life: 0.10 + Math.random() * 0.16 });
      }
      function stroke(pts, w, style) {
        ctx.beginPath();
        for (var i = 0; i < pts.length; i++) { if (i) ctx.lineTo(pts[i].x, pts[i].y); else ctx.moveTo(pts[i].x, pts[i].y); }
        ctx.lineWidth = w; ctx.strokeStyle = style; ctx.stroke();
      }
      function draw() {
        ctx.clearRect(0, 0, W, H);
        ctx.lineCap = 'round'; ctx.lineJoin = 'round';
        ctx.globalCompositeOperation = 'lighter';
        arcs.forEach(function (a) {
          var t = a.age / a.life, al = (t < 0.2 ? t / 0.2 : 1 - (t - 0.2) / 0.8) * (0.7 + 0.3 * Math.random());
          stroke(a.pts, 4, 'rgba(92,214,255,' + (0.35 * al).toFixed(3) + ')');
          stroke(a.pts, 1.2, 'rgba(235,250,255,' + (0.95 * al).toFixed(3) + ')');
          if (a.branch) {
            stroke(a.branch, 3, 'rgba(92,214,255,' + (0.25 * al).toFixed(3) + ')');
            stroke(a.branch, 0.9, 'rgba(235,250,255,' + (0.8 * al).toFixed(3) + ')');
          }
        });
        ctx.globalCompositeOperation = 'source-over';
      }
      var last = 0, running = false, raf = 0;
      function loop(now) {
        if (!running) return;
        var dt = Math.min(0.1, (now - (last || now)) / 1000); last = now;
        acc += dt;
        if (acc > 0.06 + Math.random() * 0.25) { spawn(); if (Math.random() < 0.3) spawn(); acc = 0; }
        for (var i = arcs.length - 1; i >= 0; i--) { arcs[i].age += dt; if (arcs[i].age > arcs[i].life) arcs.splice(i, 1); }
        draw();
        raf = requestAnimationFrame(loop);
      }
      function start() { if (running || document.hidden) return; running = true; last = 0; raf = requestAnimationFrame(loop); }
      function stop() { running = false; cancelAnimationFrame(raf); }
      if ('ResizeObserver' in window) new ResizeObserver(size).observe(btn); else window.addEventListener('resize', size);
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (en) { if (en[0].isIntersecting) start(); else stop(); }).observe(btn);
      } else start();
      document.addEventListener('visibilitychange', function () { if (document.hidden) stop(); else start(); });
      size();
    });
  })();

  (function wavePlayers() {
    var rows = Array.prototype.slice.call(document.querySelectorAll('.wave[data-src]'));
    if (!rows.length) return;

    var AC = window.AudioContext || window.webkitAudioContext;
    var ctx = null;
    var playing = null;

    function css(name, fallback) {
      var v = getComputedStyle(document.documentElement).getPropertyValue(name).trim();
      return v || fallback;
    }
    function fmt(t) {
      if (!isFinite(t)) return '0:00';
      var m = Math.floor(t / 60), s = Math.floor(t % 60);
      return m + ':' + (s < 10 ? '0' : '') + s;
    }

    function peaks(buf, cols) {
      var ch = buf.numberOfChannels > 1
        ? mix(buf.getChannelData(0), buf.getChannelData(1))
        : buf.getChannelData(0);
      var step = Math.max(1, Math.floor(ch.length / cols));
      var out = new Float32Array(cols * 2);
      for (var i = 0; i < cols; i++) {
        var lo = 1, hi = -1, start = i * step, end = Math.min(ch.length, start + step);
        for (var j = start; j < end; j++) {
          var v = ch[j];
          if (v < lo) lo = v;
          if (v > hi) hi = v;
        }
        if (start >= end) { lo = 0; hi = 0; }
        out[i * 2] = lo;
        out[i * 2 + 1] = hi;
      }
      return out;
    }
    function mix(a, b) {
      var out = new Float32Array(a.length);
      for (var i = 0; i < a.length; i++) out[i] = (a[i] + b[i]) * 0.5;
      return out;
    }

    function build(row) {
      var src = row.getAttribute('data-src');
      var btn = document.createElement('button');
      btn.className = 'wave-btn';
      btn.type = 'button';
      btn.setAttribute('aria-label', 'Play');
      btn.innerHTML = '<svg viewBox="0 0 12 12" aria-hidden="true"><path d="M2 1 L11 6 L2 11 Z"/></svg>';
      var canvas = document.createElement('canvas');
      canvas.className = 'wave-canvas';
      var time = document.createElement('span');
      time.className = 'wave-time';
      time.textContent = '0:00';
      row.appendChild(btn);
      row.appendChild(canvas);
      row.appendChild(time);
      row.classList.add('is-loading');

      var audio = new Audio();
      audio.preload = 'metadata';
      audio.src = src;
      var data = null, dpr = window.devicePixelRatio || 1;
      var grad = true;

      function draw() {
        var w = canvas.clientWidth, h = canvas.clientHeight;
        if (!w || !h) return;
        canvas.width = Math.round(w * dpr);
        canvas.height = Math.round(h * dpr);
        var g = canvas.getContext('2d');
        g.setTransform(dpr, 0, 0, dpr, 0, 0);
        g.clearRect(0, 0, w, h);
        if (!data) return;
        var cols = data.length / 2;
        var mid = h / 2;
        var played = audio.duration ? (audio.currentTime / audio.duration) * w : 0;
        var dim = '#3f3f42';
        var hot = '#8ec0e2';
        if (grad && played > 0) {
          var tail = Math.min(played, w * 0.45);
          var lg = g.createLinearGradient(played - tail, 0, played, 0);
          lg.addColorStop(0, '#8ec0e2');
          lg.addColorStop(1, '#dff2ff');
          hot = lg;
        }
        for (var i = 0; i < cols; i++) {
          var x = (i / cols) * w;
          var lo = data[i * 2], hi = data[i * 2 + 1];
          var y1 = mid - hi * mid * 0.92;
          var y2 = mid - lo * mid * 0.92;
          if (y2 - y1 < 1) { y1 = mid - 0.5; y2 = mid + 0.5; }
          g.fillStyle = x < played ? hot : dim;
          g.fillRect(x, y1, Math.max(1, w / cols - 0.5), y2 - y1);
        }
      }

      function flat() {
        var cols = Math.max(120, Math.round(canvas.clientWidth));
        var out = new Float32Array(cols * 2);
        for (var i = 0; i < cols; i++) { out[i * 2] = -0.06; out[i * 2 + 1] = 0.06; }
        return out;
      }

      audio.addEventListener('loadedmetadata', function () {
        row.classList.remove('is-loading');
        if (!data) { data = flat(); draw(); }
        time.textContent = fmt(audio.duration);
      });
      audio.addEventListener('error', function () { row.remove(); });

      function load() {
        if (!AC || !window.fetch) return;
        fetch(src).then(function (r) {
          if (!r.ok) throw new Error('missing');
          return r.arrayBuffer();
        }).then(function (buf) {
          if (!ctx) ctx = new AC();
          return ctx.decodeAudioData(buf);
        }).then(function (decoded) {
          var cols = Math.max(120, Math.round(canvas.clientWidth));
          data = peaks(decoded, cols);
          time.textContent = fmt(decoded.duration);
          row.classList.remove('is-loading');
          draw();
        }).catch(function () {});
      }

      btn.addEventListener('click', function () {
        if (audio.paused) {
          if (playing && playing !== audio) playing.pause();
          playing = audio;
          audio.play();
        } else {
          audio.pause();
        }
      });
      canvas.addEventListener('click', function (e) {
        if (!audio.duration) return;
        var r = canvas.getBoundingClientRect();
        audio.currentTime = ((e.clientX - r.left) / r.width) * audio.duration;
        draw();
      });
      var raf = 0;
      function tick() {
        draw();
        time.textContent = fmt(audio.duration - audio.currentTime);
        raf = requestAnimationFrame(tick);
      }
      audio.addEventListener('play', function () {
        if (!raf) raf = requestAnimationFrame(tick);
        row.classList.add('is-playing');
        btn.innerHTML = '<svg viewBox="0 0 12 12" aria-hidden="true"><rect x="2" y="1.5" width="3" height="9"/><rect x="7" y="1.5" width="3" height="9"/></svg>';
      });
      audio.addEventListener('pause', function () {
        if (raf) { cancelAnimationFrame(raf); raf = 0; }
        draw();
        row.classList.remove('is-playing');
        btn.innerHTML = '<svg viewBox="0 0 12 12" aria-hidden="true"><path d="M2 1 L11 6 L2 11 Z"/></svg>';
      });
      audio.addEventListener('ended', function () { audio.currentTime = 0; draw(); });
      window.addEventListener('resize', draw);
      load();
    }

    rows.forEach(build);
  })();

  (function bundlePicker() {
    var box = document.querySelector('.bundle-box');
    if (!box) return;
    var packs = box.querySelectorAll('button.pack[data-price]');
    var was = box.querySelector('[data-bundle-was]');
    var now = box.querySelector('[data-bundle-now]');
    if (!packs.length || !was || !now) return;

    var PLUGIN = parseFloat(box.getAttribute('data-plugin-price')) || 47;
    var OFF = 0.35;

    function money(v) {
      return '$' + (Math.round(v * 100) % 100 === 0 ? v.toFixed(0) : v.toFixed(2));
    }
    function update() {
      var sum = 0;
      packs.forEach(function (p) {
        if (p.classList.contains('is-on')) sum += parseFloat(p.getAttribute('data-price')) || 0;
      });
      was.textContent = money(PLUGIN + sum);
      now.textContent = money(PLUGIN + sum * (1 - OFF));
    }
    packs.forEach(function (p) {
      p.addEventListener('click', function () {
        var on = !p.classList.contains('is-on');
        p.classList.toggle('is-on', on);
        p.setAttribute('aria-pressed', on ? 'true' : 'false');
        update();
      });
    });
    update();
  })();

  (function videoModal() {
    var modal = document.getElementById('video-modal');
    if (!modal) return;
    var box = modal.querySelector('.vmodal-box');
    var video = modal.querySelector('video');
    var closing = null;

    function open() {
      if (closing) { clearTimeout(closing); closing = null; }
      modal.hidden = false;
      modal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      requestAnimationFrame(function () {
        requestAnimationFrame(function () { modal.classList.add('is-open'); });
      });
      if (video) { video.currentTime = 0; video.play().catch(function () {}); }
    }
    function close() {
      if (modal.hidden) return;
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      if (video) video.pause();
      closing = setTimeout(function () { modal.hidden = true; closing = null; }, 380);
    }

    document.querySelectorAll('[data-open-video]').forEach(function (b) {
      b.addEventListener('click', function (e) { e.preventDefault(); open(); });
    });
    modal.addEventListener('click', function (e) { if (!box.contains(e.target)) close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  })();

  document.querySelectorAll('[data-year]').forEach(function (el) {
    el.textContent = String(new Date().getFullYear());
  });
})();
